import React from 'react';
import { ClipboardList } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../shared/LibrarySection';
import { PageLayout } from '~/shared/PageLayout';
import { OasisDefinitionTable } from './OasisDefinitionTable';

export const OasisDefinitionLibrarySection = {
	settingsView: 'oasis-definitions',
	title: 'Oasis Definitions',
	description: 'Manage intervention definitions',
	TitleIcon: ClipboardList
} satisfies SettingsSectionItem;

export function OasisDefinitionLibrary() {
	return (
		<PageLayout
			pageHeader={{
				title: OasisDefinitionLibrarySection.title,
				description: OasisDefinitionLibrarySection.description,
				TitleIcon: OasisDefinitionLibrarySection.TitleIcon
			}}
		>
			<LibrarySection
				librarySection={OasisDefinitionLibrarySection}
				searchPlaceholder="Search task definitions by name..."
				noResultsLabel="No Oasis Definitions Found"
				noResultsSubLabel="Oasis definitions are seeded from configuration files"
				TableComponent={OasisDefinitionTable}
				searchFilterColumn="title"
			/>
		</PageLayout>
	);
}
